import { usePlayersStore } from "@/stores";

export function updatePlayerPronouns([index, value]: [number, string]) {
  const playersStore = usePlayersStore();
  const player = playersStore.players[index];
  if (!player) return;

  playersStore.update({
    player,
    property: "pronouns",
    value,
    isFromSocket: true,
  });
}
